import React from 'react';
import './NormalBtn.css';

export default function App(props) {

    var aStyle = {};
    if (props.style){
      aStyle = props.style;      
    }
  	if (props.backgroundColor){
	  	aStyle.backgroundColor = props.backgroundColor;
  	}
    
    var onClick = function(e){};
    if (props.onClick){
      onClick = props.onClick;
    }
 
    if (props.isDisabled){
      onClick = function(e){};
    }

    var className = "normalBtn";
    if (props.isHighlighted){
      className = "highlightedBtn";
    }
    return(
        <div className={className} style={{...aStyle}} onClick={onClick} id={props.id}>
          {props.title}
        </div>
      )
  
}
